// src/hooks/useLoadAvailablePlans.ts
import { useState, useEffect, useCallback } from "react";
import { useGetProjectPlansQuery } from "../redux/api";

export const useLoadPlans = (projectId: string) => {
    const [shouldFetch, setShouldFetch] = useState(false);
    const { data, isLoading, isError, refetch } = useGetProjectPlansQuery(
        { project_id: projectId },
        { skip: !shouldFetch, refetchOnMountOrArgChange: true }
    );

    useEffect(() => {
        if (shouldFetch) {
            refetch();
        }
    }, [shouldFetch, refetch]);

    useEffect(() => {
        if (!isLoading && data && !isError) {
            setShouldFetch(false);
        } else if (!isLoading && isError) {
            setShouldFetch(false);
        }
    }, [data, isError, isLoading]);

    const loadPlans = useCallback(() => {
        setShouldFetch(true);
    }, []);

    return { loadPlans, isLoading, data, isError };
};